import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getIsFetching, getPpsisWithFilter } from '../selectors';
import { fetchPpsis } from '../actions';

const usePpsis = ({ status, relatedToPpiId }) => {
  const filter = useMemo(() => ({ status, relatedToPpiId }), [
    status,
    relatedToPpiId
  ]);
  const dispatch = useDispatch();
  const isFetching = useSelector(getIsFetching);
  const ppsisWithFilter = useSelector(
    getPpsisWithFilter({
      ...filter,
      status: filter.status === 'PUBLISHEDPPSIS' ? 'PUBLISHED' : filter.status
    })
  );

  useEffect(() => {
    dispatch(
      fetchPpsis({
        ...filter,
        ...(filter.relatedToPpiId ? { ppiId: filter.relatedToPpiId } : '')
      })
    );
  }, [dispatch, filter]);

  return [isFetching, ppsisWithFilter];
};

export default usePpsis;
